import { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import * as RadixToast from '@radix-ui/react-toast';

import { Toast, ToastProps } from './Toast';
import { ToastContext } from './ToastContext';
import styles from './Toast.module.scss';

export function ToastProvider({ children }: PropsWithChildren): JSX.Element {
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const showToast = useCallback(
    (toast: ToastProps) => setToasts((prevToasts) => [...prevToasts, toast]),
    [],
  );

  const memoedValue = useMemo(
    () => ({
      showToast,
    }),
    [showToast],
  );

  return (
    <RadixToast.Provider>
      <ToastContext.Provider value={memoedValue}>
        {children}
        {toasts.map((toast, index) => (
          <Toast
            text={toast.text}
            title={toast.title}
            action={toast.action}
            withoutCloseButton={toast.withoutCloseButton}
            duration={toast.duration}
            className={toast.className}
            key={uuidv4()}
            iconType={toast.iconType}
            onOpenChange={(): void =>
              setToasts((prevToasts) =>
                prevToasts.filter((_, i) => i !== index),
              )
            }
          />
        ))}
      </ToastContext.Provider>

      <RadixToast.Viewport className={styles.toastViewPort} />
    </RadixToast.Provider>
  );
}
